/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ImportJsonTranslationsControllerGenerateJsonTranslations$Params {

/**
 * The language code for the generated translations.
 */
  languageCode: string;

/**
 * The appIdentifier of the app for which to generate translations.
 */
  appIdentifier: string;
}

export function importJsonTranslationsControllerGenerateJsonTranslations(http: HttpClient, rootUrl: string, params: ImportJsonTranslationsControllerGenerateJsonTranslations$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, importJsonTranslationsControllerGenerateJsonTranslations.PATH, 'get');
  if (params) {
    rb.query('languageCode', params.languageCode, {});
    rb.query('appIdentifier', params.appIdentifier, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

importJsonTranslationsControllerGenerateJsonTranslations.PATH = '/import-json-translations/generate';
